module.exports = __webpack_public_path__ + "static/media/grin-regular-active.ca6255a5.svg";